module.exports = __webpack_public_path__ + "img/arianna-natale_old.09e7cc25.svg";